<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        :class="classes"
        >
        <path
            d="M20 12H4"
            fill="none"
            :stroke="stroke"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
<script >
export default {
    props: {
        stroke: {
            type: String,
            default: () => "currentColor",
        },
        classes: {
            type: String,
            default: () => "w-5 md:w-10 h-10 xs:w-3 xs:h-3"
        }
    },
}
</script>
<style scoped>
</style>